import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import BuyingServices from './pages/BuyingServices';
import MortgageCalculator from './pages/MortgageCalculator';
import Search from './pages/Search';
import SellingServices from './pages/SellingServices';
import AdminReviews from './pages/AdminReviews';
import AdminListings from './pages/AdminListings';
import Listings from './pages/Listings';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/buying-services" element={<BuyingServices />} />
          <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
          <Route path="/search" element={<Search />} />
          <Route path="/selling-services" element={<SellingServices />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="/admin/listings" element={<AdminListings />} />
          <Route path="/listings" element={<Listings />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
